const actions = {
  SET_STATE: "port/SET_STATE",
  LIST: "port/LIST",
  CREATE: "port/CREATE",
  DETAIL: "port/DETAIL",
  UPDATE: "port/UPDATE",
  DELETE: "port/DELETE",
};

export default actions;
